import { useSelector } from 'react-redux';
import { useOutletContext } from 'react-router-dom';
// @ts-ignore
import permissions from 'invitemember-permissions-model';
import { getAuthUser, getProject, getUserPermissions } from '@/selectors';
import { OutletContext } from '@/types';

export const useHasPermission = (requiredPermission?: {} | undefined): boolean => {
	const { auth } = useOutletContext<OutletContext>();
	const project = useSelector(getProject);
	const userPermissions = useSelector(getUserPermissions);
	const user = useSelector(getAuthUser);

	if (project?.creatorUserId === user?.userId) {
		return true;
	}

	try {
		const userUnpackedPermissions = permissions.unpackPermissions(userPermissions);
		return permissions.checkHasPermission(requiredPermission, userUnpackedPermissions);
	} catch {
		return false;
	}
};
